import React from 'react';
import { Partner } from './Partner';
import { partnerList } from '../../contents/partners';

import { StyledNavigationList, StyledHeading, StyledPartnerSection, StyledLogoContainer } from './PartnerList.styled';

interface PartnerListItem {
  partnerType: string;
  url: string;
  logo: string;
}

export const PartnerList: React.FC = () => {
  return (
    <StyledPartnerSection>
      <StyledHeading>Partners</StyledHeading>
      <StyledNavigationList>
        <StyledLogoContainer>
          {partnerList.map((partner: PartnerListItem) => (
            <Partner key={partner.url} partnerType={partner.partnerType} url={partner.url} logo={partner.logo} />
          ))}
        </StyledLogoContainer>
      </StyledNavigationList>
    </StyledPartnerSection>
  );
};
